import { render, staticRenderFns } from "./student.vue?vue&type=template&id=4b4ddb92&scoped=true&"
import script from "./student.vue?vue&type=script&lang=js&"
export * from "./student.vue?vue&type=script&lang=js&"
import style0 from "./student.vue?vue&type=style&index=0&id=4b4ddb92&scoped=true&lang=css&"
import style1 from "./student.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ddb92",
  null
  
)

export default component.exports